<div class="custom-center" style="flex-direction: column">
    <h5 class="mb-0" *ngIf="!data">Puedes seleccionar un archivo para cargar o arrastrarlo aquí.</h5>
    <small *ngIf="!data"><b>* Solo extensión .xlsx</b></small>
    <div *ngIf="!data" pTooltip="Cargar archivo" class="mt-3 upload-button custom-center btn btn-primary p-3"
        (click)="file.click()">
        <i class="pi pi-upload" style="color: white; font-size: 1.4rem;"></i>
    </div>
    <small class="mt-4" *ngIf="filename">Nombre del archivo: <b>{{filename}}</b></small>

    <h5 class="mb-0 mt-4" *ngIf="!data">También tiene la opción de realizar la carga manual.</h5>
    <div *ngIf="!data" pTooltip="Carga manual" class="my-3 custom-center btn btn-primary add-btn"
        style="border-radius: 9999px" (click)="cargaManual()">
        <i class="pi pi-plus-circle p-0 m-0" style="color: white; font-size: 2rem;"></i>
    </div>
</div>
<input #file id="upload-file" type="file" (change)="onFileChange($event)" accept=".xlsx" hidden>

<div class="row" *ngIf="data">
    <div class="col-12 text-center">
        <label><b>Año perteneciente a la planilla:</b></label>
        <p-dropdown [style]="{ width: '100%' }" placeholder="Seleccione el año de la carga..." optionLabel="value"
            [options]="years" [(ngModel)]="selectedYear" appendTo="body" />
    </div>
</div>

<div class="mt-3" *ngFor="let planilla of data">
    <h4>{{ planilla.tipo }}</h4>
    <div class="table-container">
        <ng-container *ngFor="let lob of planilla.datos; let i = index">
            <app-rows (delete)="onDelete($event)" [user]="user" [lob]="lob" [lobs]="lobs" [tipo]="planilla.tipo"
                [index]="i" />
        </ng-container>

        <!-- Añade rows en la planilla -->
        <div class="row mt-2">
            <div class="col-12 text-center">
                <p (click)="onAdd(planilla.tipo)" class="add-text" style="cursor: pointer">Agregar LoB +</p>
            </div>
        </div>
        <!-- Fin añade rows en la planilla -->

    </div>
</div>

<div class="row mt-4" *ngIf="data">
    <div class="col-12 text-center">
        <button class="btn btn-primary" (click)="upload()">Cargar datos</button>
    </div>
</div>
<app-dialog #dialog />

<app-top-bottom-button />